import axios from 'axios'

export default{
  namespaced: true,
  state: {
    procedures: null,
    procedureForEdit: {
      eventType: {},
      eventCategory: {},
      eventSubCategory: {}
    },
    eventTypeOptions: []
  },

  mutations: {
    updateEventTypes (state, types) {
      console.log('setting event types: ' + JSON.stringify(types, null, 2))
      state.eventTypeOptions = types
    }
  },
  getters: {
  },
  actions: {
    async loadEventTypes ({commit, state, rootState}) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/eventTypes')
      try {
        await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/eventTypes'
        )
          .then(result => commit('updateEventTypes', result.data.eventTypes))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getProcedureForEdit ({commit, state, rootState}, procedureId) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/procedures/${procedureId}`
        return axios.get(requestString)
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getProcedureForNew ({commit, state, rootState}) {
      try {
        return axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/procedures/create`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async createQuestion ({commit, state, rootState}, index) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/procedures/questions/create`
        )
          .then(result => {
            result.data.isNew = true
            return result
          })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveProcedure ({commit, state, rootState, dispatch}, procedure) {
      try {
        const saveProcedure = procedure
        saveProcedure.companyId = rootState.userCurrentCompany.companyId
        console.log('Saving procedure: ' + JSON.stringify(saveProcedure, null, 2))
        await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/procedures',
          saveProcedure).then(data => {
          console.log('Data is: ' + data)
        })
      } catch (e) {
        if (e.response && e.response.status === 400 && e.response.data && Array.isArray(e.response.data.issues)) {
          var validationError = new Error('Procedure save was rejected due to validation issues.')
          validationError.issues = e.response.data.issues
          throw validationError
        }
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async duplicateProcedure ({commit, state, rootState, dispatch}, procedure) {
      try {
        const saveProcedure = procedure
        saveProcedure.companyId = rootState.userCurrentCompany.companyId
        console.log('Saving procedure: ' + JSON.stringify(saveProcedure, null, 2))
        await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/procedure/duplicate',
          saveProcedure
        ).then(data => {
          console.log('Data is: ' + data)
        })
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async checkForDuplicateProcedure ({commit, state, rootState, dispatch}, procedure) {
      try {
        const checkForDupeProcedure = procedure
        checkForDupeProcedure.companyId = rootState.userCurrentCompany.companyId
        console.log('Checking for duplicates: ' + JSON.stringify(checkForDupeProcedure, null, 2))
        var returnValue = await axios.post(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/procedure/checkforduplicate',
          checkForDupeProcedure
        ).then((response) => {
          console.log('IsDuplicate:', response.data)
          return response.data
        })
        return returnValue
      } catch (e) {
        this.apiMessage = `Error: the server responded with '${
          e.response.status
        }: ${e.response.statusText}'`
      }
    },
    async getProcedures ({commit, state, rootState}, request) {
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/procedures'
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getRoutineTaskProcedures ({commit, state, rootState}, request) {
      try {
        var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/routineTasks/procedures`
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    }
  }
}
